import { useContext, useEffect, useState } from "react";
import Navbar from "./navbar"
import Header from "./header";
import ChatBurbujaGlobal from "./ChatBurbujaGlobal";
import AlertasMejoramientosBurbuja from "./AlertasMejoramientosBurbuja";
import AlertasObrasBurbuja from "./AlertasObrasBurbuja";
import NotificacionesGlobal from "./NotificacionesGlobal";
import TelegramModal from "./TelegramModal";
import { PostLoginNotificacionesModal } from "./PostLoginNotificacionesModal";
import { NotificacionesProvider } from "../context/NotificacionesContext";
import { ChatSoporteProvider } from "../context/ChatSoporteContext";
import { AuthContext } from "../context/authContext";
import { initiateSocketConnection } from "../service/socketio";


//import React from 'react'

//NOTA: usado en PrivateRoutes para menu solo de paginas privadas

export const LayoutPriv = ({ children }) => {
	const auth = useContext(AuthContext);
	const { user, role, userId } = auth || {};

	const [socket, setSocket] = useState(null);
	const [isSocketConnected, setIsSocketConnected] = useState(false);

	// El socket es único y compartido (ver service/socketio.js: si ya hay una
	// conexión viva se reusa). Se abre acá porque LayoutPriv es el padre de
	// TODAS las páginas privadas: así el chat de soporte (y las burbujas que
	// escuchan eventos) funcionan desde cualquier pantalla, no solo desde Inicio.
	useEffect(() => {
		const s = initiateSocketConnection();
		setSocket(s);

		const onConnect = () => setIsSocketConnected(true);
		const onDisconnect = () => setIsSocketConnected(false);

		s.on('connect', onConnect);
		s.on('disconnect', onDisconnect);
		if (s.connected) setIsSocketConnected(true);

		return () => {
			s.off('connect', onConnect);
			s.off('disconnect', onDisconnect);
			// El socket es compartido: el que lo cierra (al desloguearse, que
			// desmonta LayoutPriv) es esta app, no cada página.
			try { s.close(); } catch (e) { }
		};
	}, []);

	return (
		<>
			<NotificacionesProvider>
				{/* El estado del chat de soporte va por encima del Header: el
				    navbar (que va dentro del Header) tiene el item del menú Admin
				    con el contador de la cola, y tiene que abrir el mismo panel
				    que el botón flotante. */}
				<ChatSoporteProvider socket={socket}>
					<Header >
						<Navbar />
					</Header>
					<main>{children}</main>
					{/* Burbuja global del Chat Inteligente (Fase 0, solo admin) */}
					<ChatBurbujaGlobal />
					{/* Burbuja global de notificaciones de pagos y certificaciones */}
					<NotificacionesGlobal />
					{/* Burbuja global de alertas del Área de Mejoramientos (90 días) */}
					<AlertasMejoramientosBurbuja />
					{/* Burbuja global de alertas de Obras (anticipo sin acta) */}
					<AlertasObrasBurbuja />
					{/* Modal de notificaciones pendientes al loguearse */}
					<PostLoginNotificacionesModal />
					{/* Chat de soporte (admin <-> usuario).Va acá para que se pueda
					    abrir desde cualquier pantalla, no solo desde Inicio. */}
					<TelegramModal role={role} user={user} userId={userId} socket={socket} isSocketConnected={isSocketConnected} />
				</ChatSoporteProvider>
			</NotificacionesProvider>
			{/* <Footer /> */}
		</>
	)
}
